/*
Version 0.100

Made by: Finally // Aleks Schakel // www.finally.nl // aleks@finally.nl
Copyright 2016 - 2018.

!Changelog

2018
	17-10-2018
	- [BORN] This class is born. Hooray!

!Usage

	-
	
!Wishlist

	none
	
*/
  
var specific_interactions_init = {};

(function(){
	 
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	
	/**
	None yet
	**/
	 
	// PRELOAD & DOCUMENT READY  *****************************************************************
	// PRELOAD & DOCUMENT READY *****************************************************************
	// PRELOAD & DOCUMENT READY ******************************************************************
	// PRELOAD & DOCUMENT READY ******************************************************************
	
	this.onready = function() {
		
		/**
		Unbind: Unnecessary listeners
		**/
		//$(document).off('click.cookieWallSubmit');
		//$(document).off('click.cookieWallTabs');
		//$(document).off('click.cookieBarSubmit');
		
		/*
		Close the mobilemenu always on route
		*/
		specific_mobilemenu.toggle(1);
		
		/*
		Trigger: Instagram
		*/
		//specific_instagram.onready('thumb',8,true);

		/*
		Trigger: Facebook
		*/
		//specific_facebook.onready(6,true);
		
		/*
		Catch and active URL
		*/
		var _url_active_main = './';
		
		$('.js-nav-item').removeClass('active');
		
		if(url[3] !== '') { 
			_url_active_main = url[2] + '/' + url[3]; 
		} else {
			if(url[2] !== '') { 
				_url_active_main = url[2];
			}
		}

		if(_url_active_main !== '') {
			$('.js-nav-item[data-go-url="' + _url_active_main + '"]').addClass('active');
		}

		/*
		Sub
		*/
		$('.js-nav-item-sub').removeClass('active');

		var _url_active_sub = '';

		if(
			url[4] !== ''
		) { 

			_url_active_sub = url[2] + '/' + url[3] + '/' + url[4]; 

		}

		if(_url_active_sub !== '') {
			$('.js-nav-item-sub[data-go-url="' + _url_active_sub + '"]').addClass('active');
		}

		/*
		Search
		*/
		specific_search.onready();

		/*
		Swiper: Team
		*/
		specific_team_slideshow.onready();

		/*
		Swiper: Office
		*/
		specific_office_slideshow.onready();

		/*
		Swiper: Happy clients
		*/
		// var swiperClients = new Swiper('.js-happyclients',{
		// 	navigation: {
		// 	  nextEl: '.js-slide-next',
		// 	  prevEl: '.js-slide-prev',
		// 	},
		// 	freeMode: true,
		// 	slidesPerView: 6,
		// 	loop: true,
      	// 	spaceBetween: 30,
      	// 	autoplay: {
		// 	   delay: 2000,
		// 	},
		// 	breakpoints: {
			    
		// 	    700: {
		// 	      slidesPerView: 3,
		// 	      spaceBetween: 30
		// 	    }

		// 	  }
		// });

		/*
		Swiper: Spotlight
		*/
		var swiperSpotlight = new Swiper('.js-spotlight',{
			slidesPerView: 1,
      		spaceBetween: 0,
      		loop:true,
      		autoplay: {
			   delay: 2000,
			},
			pagination: {
		      el: '.swiper-pagination',
					clickable: true,
		        renderBullet: function (index, className) {
		        	return '<span class="' + className + ' item"></span>';
		    	}
		    },
		    on: {
			    init: function () {
					var _category = $('.swiper-slide-active').data('category');
					$('.js-spotlight-category').html(_category);
			    },
			}
		});

		swiperSpotlight.on('slideChange', function () {
			
			setTimeout(function() {
				/*
				Get: Name
				*/
				var _category = $('.swiper-slide-active').data('category');
				$('.js-spotlight-category').html(_category);

				/*
				Get: Link
				*/
				var _link = $('.swiper-slide-active').data('link');
				if(_link != '') {
					$('.js-spotlight-category').attr('href',_link);
				}
			},200);

		});

		/*
		Swiper: Spotlight
		*/
		var swiperSpotlight2 = new Swiper('.js-spotlight2',{
			slidesPerView: 1,
      		spaceBetween: 0,
      		loop:true,
      		autoplay: {
			   delay: 2000,
			}
		});		

		/*
		Tooltipster: Init
		*/
		 $('.tooltip').tooltipster({
		 	maxWidth	: 550,		 	
		 	delay 		: 0,
		 	speed 		: 0
		 });
		
	};
	
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	
	// none
	
}).apply(specific_interactions_init); 
